export type ViewMode = "list" | "cards" | "table";

export const DEFAULT_VIEW_MODES: ViewMode[] = ["list", "cards", "table"];

/** Mobile collection pages: Cards + List only. */
export const MOBILE_COLLECTION_VIEW_MODES: ViewMode[] = ["cards", "list"];

/**
 * Intersect page-allowed modes with the mobile Cards/List set.
 * Falls back to Cards+List when the page has neither.
 */
export function resolveCollectionViewModes(
  isDesktop: boolean,
  allowedModes: ViewMode[],
): ViewMode[] {
  if (isDesktop) return allowedModes;
  const mobile = MOBILE_COLLECTION_VIEW_MODES.filter((m) =>
    allowedModes.includes(m),
  );
  return mobile.length > 0 ? mobile : [...MOBILE_COLLECTION_VIEW_MODES];
}

/** Coerce table to list when showing the mobile command bar. */
export function coerceMobileCollectionViewMode(mode: ViewMode): ViewMode {
  if (mode === "cards" || mode === "list") return mode;
  return "list";
}
